import { useEffect } from 'react';

import clsx from 'clsx';
import { useTimeoutFn } from 'react-use';

import Close from '~/icons/close.svg';
import { Icon } from '~/shared/components/Icon/Icon';
import { NotificationOptions } from '~/shared/hooks/useNotification/useNotificationModel';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './notification.module.css';

type Props = NotificationOptions & {
	onDismiss: () => void;
};

export const Notification = ({ text, onDismiss, onClick, severity = 'error', duration }: Props) => {
	const { translate } = useTranslation();
	const [, cancel, restart] = useTimeoutFn(onDismiss, duration);

	useEffect(() => {
		if (!duration) {
			cancel();
		}
	}, [cancel, duration]);

	return (
		<div
			className={clsx(styles.root, styles[severity])}
			aria-live="polite"
			role="button"
			tabIndex={0}
			onClick={onClick || onDismiss}
			onFocus={cancel}
			onMouseEnter={cancel}
			onMouseLeave={duration ? restart : undefined}
			onTouchStart={cancel}
			onTouchEnd={duration ? restart : undefined}
		>
			<div className={styles.content}>
				{text}
				<button
					type="button"
					className={styles.closeButton}
					onClick={onDismiss}
				>
					<Icon>
						<Close title={translate('accessibility.close-icon-title')} />
					</Icon>
				</button>
			</div>
		</div>
	);
};
